import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { AuthService } from '@core/services/auth.service';
import { IdleService } from '@core/services/idle.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private authService: AuthService,
    private idleService: IdleService
  ) {}

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      const idleTimeoutMs = environment.IDLE_TIMEOUT_MINUTES * 60 * 1000;
      this.idleService.start(idleTimeoutMs);
    }
  }

  ngOnDestroy(): void {
    this.idleService.stop();
  }
}